import { useContext, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import InputField from "../../InputField";
import AlertModal from "../AlertModal";
import endpoints from "../../../Helpers/Endpoints";
import { apiPutRequest } from "../../../Helpers/Requests";
import { AppContext } from "../../../Context/AppContext";
import { useTranslation } from "react-i18next";

const AddLinkModal = ({ open, onClose, jobId, existingLink, onSave }) => {
  const { profileData } = useContext(AppContext);
  const [link, setLink] = useState("");
  const [actionLoader, setActionLoader] = useState(false);
  const { t } = useTranslation("job-action-modals", {
    keyPrefix: "addLinkModal",
  });

  const isEditMode = !!existingLink;

  useEffect(() => {
    if (open && existingLink) {
      setLink(existingLink);
    } else if (!open) {
      setLink("");
    }
  }, [open, existingLink]);

  const handleActionClick = async () => {
    try {
      setActionLoader(true);
      // Auto-prepend https:// if no protocol is provided
      const normalizedLink = link.trim().match(/^https?:\/\//) ? link.trim() : `https://${link.trim()}`;
      const requestBody = {
        online_link: normalizedLink,
      };

      await apiPutRequest(
        endpoints.updateOnlineJobMeetingLink(jobId, profileData.id),
        requestBody
      );

      onSave?.(normalizedLink);
      onClose();
      setLink("");
    } catch (error) {
      console.error(error);
    } finally {
      setActionLoader(false);
    }
  };

  return (
    <AlertModal
      open={open}
      onClose={onClose}
      onActionClick={handleActionClick}
      title={isEditMode ? t("editTitle") : t("title")}
      actionBtnText={isEditMode ? t("saveChangesButton") : t("saveButton")}
      actionLoader={actionLoader}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <Typography
          sx={{
            fontSize: "15px",
            fontWeight: 500,
            color: "rgba(72, 72, 72, 1)",
            lineHeight: "15px",
          }}
        >
          {t("description")}
        </Typography>

        <InputField
          name="link"
          placeholder={t("placeholder")}
          value={link}
          onChange={(e) => setLink(e.target.value)}
        />
      </Box>
    </AlertModal>
  );
};

export default AddLinkModal;
